import React, { useState } from "react";
import { FiMail, FiLock, FiFileText } from "react-icons/fi";
import { HiBuildingOffice2 } from "react-icons/hi2";
import { MdMarkEmailRead } from "react-icons/md";
import { fetchUpdateDados } from "../../integration/alterardados/fetchUpdateDados";
import { formatToCPFOrCNPJ } from "brazilian-values";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const MeuPerfil = () => {
  const razaosocial =
    localStorage.getItem("@medusapayments:name") || "User Name";

  const [senhaAtual, setSenhaAtual] = useState("");
  const [novaSenha, setNovaSenha] = useState("");
  const [email, setEmail] = useState("");
  const [senhaValida, setSenhaValida] = useState(true);

  async function functionUpdated() {
    if (!email && !novaSenha) {
      toast.error("Preencha o novo e-mail ou a nova senha para salvar.");
      return;
    }

    if (!senhaAtual) {
      toast.error("Você precisa informar a senha atual para alterar os dados.");
      return;
    }

    try {
      await fetchUpdateDados(
        email || undefined,
        senhaAtual,
        novaSenha || undefined
      );
      toast.success("Alterações salvas com sucesso!");
      setSenhaValida(true);
    } catch (erro) {
      if (erro?.error?.includes("Senha atual incorreta")) {
        setSenhaValida(false);
      } else {
        toast.error("Erro ao atualizar os dados. Verifique e tente novamente.");
      }
    }
  }

  return (
    <div className="flex items-center  justify-center">
      <div className="bg-white border border-gray-200 p-6 rounded-2xl shadow-md w-full  ">
        <h2 className="text-xl font-light text-center text-[#0c0c0c] mb-3">
          Informações do Usuário
        </h2>
        <p className="text-xs text-gray-500 text-center mb-5">
          Dados pessoais e de acesso.
        </p>

        {/* Informações apenas leitura */}
        <div className="bg-gray-50 border border-gray-200 rounded-xl p-3 mb-4 space-y-2 text-sm text-gray-600">
          {/*   <div className="flex items-center">
            <HiBuildingOffice2 className="h-4 w-4 text-[#a48f74] mr-2" />
            <span>{formatToCPFOrCNPJ("")}</span>
          </div> */}
          <div className="flex items-center">
            <FiFileText className="h-4 w-4 text-[#a48f74] mr-2" />
            <span>{razaosocial}</span>
          </div>
          <div className="flex items-center">
            <MdMarkEmailRead className="h-4 w-4 text-[#a48f74] mr-2" />
            <span>fsdfdsfsd@gmail.com</span>
          </div>
        </div>

        {/* Email */}
        <div className="flex items-center border border-[#c2c2c2] py-1.5 px-3 rounded-xl mb-3">
          <FiMail className="h-4 w-4 text-[#a48f74]" />
          <input
            type="email"
            placeholder="Novo e-mail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="pl-2 bg-transparent w-full text-sm text-gray-600 outline-none border-none"
          />
        </div>

        {/* Nova Senha */}
        <div className="flex items-center border border-[#c2c2c2] py-1.5 px-3 rounded-xl mb-3">
          <FiLock className="h-4 w-4 text-[#a48f74]" />
          <input
            type={"text"}
            placeholder="Nova senha"
            value={novaSenha}
            onChange={(e) => setNovaSenha(e.target.value)}
            className="pl-2 bg-transparent w-full text-sm text-gray-600 outline-none border-none"
          />
        </div>

        {/* Senha Atual */}
        <div
          className={`flex items-center border py-1.5 px-3 rounded-xl mb-3 ${
            senhaValida ? "border-[#c2c2c2]" : "border-red-400"
          }`}
        >
          <FiLock className="h-4 w-4 text-[#a48f74]" />
          <input
            type="text"
            placeholder="Senha atual"
            value={senhaAtual}
            onChange={(e) => setSenhaAtual(e.target.value)}
            className="pl-2 bg-transparent w-full text-sm text-gray-600 outline-none border-none"
          />
        </div>
        {!senhaValida && (
          <p className="text-xs text-red-500 mb-3 ml-2">
            Senha incorreta. Verifique e tente novamente.
          </p>
        )}

        <button
          onClick={functionUpdated}
          className="w-full bg-[#767676] py-2 text-sm rounded-xl text-white flex items-center justify-center"
        >
          Salvar Alterações
        </button>
      </div>
    </div>
  );
};

export default MeuPerfil;
